module.exports = __webpack_public_path__ + "media/images/xpass/deals-loader-691277f733ba96de4eed7bca8abd8f40.svg";